module.exports = __webpack_public_path__ + "img/map_en.97523876.png";